import React from 'react';

import { SelectorsAndInfosContainer } from './styledComponents';

export const FullScreenModalContentSelectorsAndInfos = (props) => (
  <SelectorsAndInfosContainer>{props.children}</SelectorsAndInfosContainer>
);

export default FullScreenModalContentSelectorsAndInfos;
